export const SPARTACUS_NOTE_TYPE_OPTIONS = [
  'Call',
  'Email',
  'WhatsApp',
  'Internal',
]

export const SPARTACUS_NOTE_OUTCOME_OPTIONS = [
  'No answer',
  'Spoke',
  'Follow-up needed',
  'Closed',
]

export const SPARTACUS_NOTE_DEFAULT_TYPE = 'Call'
export const SPARTACUS_NOTE_DEFAULT_OUTCOME = 'No answer'
export const SPARTACUS_NOTE_TEXT_MAX_LENGTH = 2000

/** Future v1.1: simple search in the notes modal once note volume grows. */
export const SPARTACUS_NOTES_SEARCH_FOLLOW_UP =
  'Add searchable notes filter in the Spartacus customer notes modal.'
